import { isNetworkError } from "@/shared/errors";

/**
 * Why a submission failed, said for the person who pressed the submit.
 *
 * `network` is the browser failing to reach Roboto at all, whose own wording
 * ("Failed to fetch") names nothing a person can act on. `rejected` is
 * everything else, where the server's reason is the most useful thing to show.
 */
export interface SubmitError {
  kind: "network" | "rejected";
  message: string;
}

function networkMessage(mode: "create" | "edit", resource: string): string {
  return mode === "create"
    ? `Couldn't reach Roboto to create this ${resource}. Check your network connection, then try again.`
    : "Couldn't reach Roboto to save your changes. Check your network connection, then try again.";
}

function fallbackMessage(mode: "create" | "edit", resource: string): string {
  return mode === "create"
    ? `Something went wrong creating this ${resource}.`
    : `Something went wrong saving this ${resource}.`;
}

/**
 * @param resource What the form writes, as the messages name it ("trigger").
 */
export function submitError(
  error: unknown,
  mode: "create" | "edit",
  resource: string,
): SubmitError {
  if (isNetworkError(error)) {
    return { kind: "network", message: networkMessage(mode, resource) };
  }
  return {
    kind: "rejected",
    message:
      error instanceof Error && error.message.length > 0
        ? error.message
        : fallbackMessage(mode, resource),
  };
}
